<template>
  <van-popup :value="value" class="camp-student-popup" get-container="body" @input="close">
    <div class="dialog-title">选择学员</div>
    <div class="dialog-sub">本中心学员，可多选</div>
      <div class="search-bar">
        <input
          v-model="keyword"
          type="search"
          enterkeyhint="search"
          placeholder="搜索姓名/医院"
          @keyup.enter="search"
          @search="search"
        >
        <button class="search-btn" type="button" @click="search">
        <i class="search-glass"></i>
        <span>搜索</span>
      </button>
    </div>
    <div class="pick-head">
      <span class="pick-all" @click="toggleAll">全选</span>
      <span class="pick-count">已选{{ draft.length }}人</span>
    </div>
    <div class="student-list">
      <div class="picker-state" v-if="!loading && !filteredStudents.length">暂无可选学员</div>
      <div class="student-row" v-for="item in filteredStudents" :key="item.id" @click="toggleStudent(item.id)">
        <img class="check-icon" :src="isSelected(item.id) ? checkedIcon : emptyIcon" alt="">
        <img class="student-avatar" src="@/assets/images/researchCamp/avatar.png" alt="">
        <div class="student-main">
          <div class="student-name">{{ item.name }}</div>
          <div class="student-hospital">{{ item.hospital || item.departmentText || item.positionTitle || ' ' }}</div>
        </div>
      </div>
    </div>
    <div class="dialog-actions">
      <button type="button" class="btn-cancel" @click="close">取消</button>
      <button type="button" class="btn-ok" @click="confirm">确定</button>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'CampStudentPicker',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    students: {
      type: Array,
      default () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectedIds: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      checkedIcon: require('@/assets/images/researchCamp/ic_x_x.svg'),
      emptyIcon: require('@/assets/images/researchCamp/ic_x_w.svg'),
      keyword: '',
      appliedKeyword: '',
      draft: []
    }
  },
  computed: {
    // 按已确认的关键字过滤学员
    filteredStudents () {
      const keyword = this.appliedKeyword
      if (!keyword) return this.students
      return this.students.filter(item => [item.name, item.hospital, item.departmentText, item.positionTitle]
        .filter(Boolean).join('').indexOf(keyword) > -1)
    }
  },
  watch: {
    // 弹窗打开时重置搜索和勾选
    value (visible) {
      if (!visible) return
      // 再次打开时清空搜索，勾选回到页面当前已选
      this.keyword = ''
      this.appliedKeyword = ''
      this.draft = this.selectedIds.slice()
    }
  },
  methods: {
    // 点搜索、回车或键盘右下角搜索才按姓名、医院过滤
    search () {
      this.appliedKeyword = this.keyword.trim()
    },
    // 取消和点遮罩都不回写已选
    close () {
      this.$emit('input', false)
    },
    // 确定后把勾选的学员 id 交回页面
    confirm () {
      this.$emit('confirm', this.draft.slice())
      this.$emit('input', false)
    },
    // 学员是否已勾选
    isSelected (id) {
      return this.draft.indexOf(id) > -1
    },
    // 勾选或取消学员
    toggleStudent (id) {
      const index = this.draft.indexOf(id)
      if (index > -1) {
        this.draft.splice(index, 1)
      } else {
        this.draft.push(id)
      }
    },
    // 全选只作用于当前搜索结果
    toggleAll () {
      const ids = this.filteredStudents.map(item => item.id)
      const allOn = ids.length && ids.every(id => this.draft.indexOf(id) > -1)
      if (allOn) {
        this.draft = this.draft.filter(id => ids.indexOf(id) === -1)
        return
      }
      ids.forEach(id => {
        if (this.draft.indexOf(id) === -1) this.draft.push(id)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.camp-student-popup {
  display: flex;
  flex-direction: column;
  width: 320px;
  max-height: 540px;
  border-radius: 16px;
  background: #fff;
  overflow: hidden;
}

.dialog-title {
  padding: 14px 16px 0;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.8);
}

.dialog-sub {
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: #81766f;
}

.search-bar {
  display: flex;
  align-items: center;
  height: 32px;
  margin: 8px 16px 0;
  padding-left: 14px;
  padding-right: 3px;
  border-radius: 25px;
  background: #f9f8f7;

  input {
    flex: 1;
    min-width: 0;
    border: 0;
    background: transparent;
    font-size: 13px;
    color: #000;
    -webkit-appearance: none;
    appearance: none;

    &::placeholder {
      color: #c1bbb3;
    }

    &::-webkit-search-cancel-button,
    &::-webkit-search-decoration {
      -webkit-appearance: none;
      appearance: none;
    }
  }
}

.search-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 26px;
  border: 0;
  border-radius: 25px;
  background: rgba(213, 207, 201, 0.5);
  font-size: 13px;
  color: #000;
  flex-shrink: 0;
}

.search-glass {
  position: relative;
  width: 9px;
  height: 9px;
  margin-right: 2px;
  border: 1px solid #000;
  border-radius: 50%;
  box-sizing: border-box;

  &::after {
    content: '';
    position: absolute;
    right: -3px;
    bottom: -1px;
    width: 4px;
    height: 1px;
    background: #000;
    transform: rotate(45deg);
  }
}

.pick-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px 4px 22px;
}

.pick-all {
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  color: #eb1700;
}

.pick-count {
  font-size: 11px;
  font-weight: 400;
  line-height: 20px;
  color: #81766f;
}

.student-list {
  flex: 1;
  overflow: auto;
  padding: 0 16px 8px 22px;
}

.picker-state {
  padding: 20px 0;
  color: #a39992;
  text-align: center;
  font-size: 13px;
}

.student-row {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.check-icon {
  width: 15px;
  height: 15px;
  margin-right: 9px;
  flex-shrink: 0;
}

.student-avatar {
  width: 42px;
  height: 42px;
  margin-right: 8px;
  border-radius: 50%;
  object-fit: cover;
  overflow: hidden;
  flex-shrink: 0;
}

.student-main {
  flex: 1;
  min-width: 0;
}

.student-name {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #000;
}

.student-hospital {
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: #81766f;
}

.dialog-actions {
  display: flex;
  padding: 12px 16px 16px;

  button {
    flex: 1;
    height: 40px;
    border: 0;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 400;
  }

  .btn-cancel {
    margin-right: 12px;
    color: #81766f;
    background: #f3f1f0;
  }

  .btn-ok {
    color: #fff;
    background: #eb1700;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/researchCamp/components/CampStudentPicker.vue